import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-01/lesson-11/task-02";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "What is the phase shift between the two dots (yellow and green) in the following</br>case? What is the phase velocity along the direction s knowing that the velocity</br>along the direction s<sub>0</sub> is 343 m/s? Note that θ stands for the angle between both</br>directions. In the colormap, red is maximum, grey is zero and blue is minimum.",
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 1,
      colsSize: [2, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/11/task/task-2.svg`,
                },
              },
              styles: {
                padding: "7%",
              },
            },
          },
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
